export default __webpack_public_path__ + "static/media/promo-banner-learn-earn.d3978806.svg";